import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import "../../css/Layout.css";
import Footer from "./Footer";
import React from "react";
import { useLayout } from "../../context/LayoutContext";

export default function Layout() {
  const { tabs, activeTabLink, closeTab, handleTabClick } = useLayout();

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout-content">
        <Navbar />

        {tabs.length > 0 && (
          <div className="tab-bar">
            {tabs.map(tab => (
              <div
                className={`tab ${tab.link === activeTabLink ? "active" : ""}`}
                key={tab.link}  >
                <span
                  onClick={() => handleTabClick(tab.link)}
                  style={{ cursor: "pointer" }}
                >
                  {tab.name}
                </span>

                <button className="tab-close" onClick={() => closeTab(tab.link)}>×</button>
              </div>
            ))}
          </div>
        )}

        <main className={`main-content ${tabs.length > 0 ? "card-style" : ""}`}>
          <Outlet />
        </main>

        <Footer />
      </div>
    </div>
  );
}
